import * as React from 'react';
import { useFormik } from 'formik';
import { FLEX_COLUMN, FLEX_ROW } from '../../layout/flexBox';
import { FORM_COLUMN } from '../../forms/styles/form';
import { btnStyle } from '../../forms/styles/button';
import { css } from '@emotion/core';
import LocalInput from '../../localization/LocalInput';
import { INPUT } from '../../forms/styles/input';
import LocalBtn from '../../localization/LocalBtn';
import LocalDiv from '../../localization/LocalDiv';
import { Str } from '../../localization/translationKeys';
import { forgotPasswordEmailFormValidation } from '../formValidations';
import { ERROR_MSG } from '../../forms/styles/messages';
import Msg from '../../localization/Msg';
import { FIELDSET_DEFAULT } from '../../layout/fieldSetStyle';
import { COLORS } from '../../globalStyle/colors';


const styles = {
  header:   css`margin-bottom: 16px;`,
  fieldset: FIELDSET_DEFAULT,
  form:     [FLEX_COLUMN, FORM_COLUMN],
  errorMsg: [FLEX_ROW, ERROR_MSG, css`align-items: center;`],
  input:    INPUT(),
  btn:      btnStyle.primary(COLORS.GREEN),
};


type Props = {
  className?: string;
  getSecurityQuestion: (emailAddress: string) => void;
  setEmailAddress: (emailAddress: string) => void;
  emailAddressNotFound: boolean;
  isLoading: boolean;
};


/**
 * ForgotPasswordEmailForm: a component which provides a form for users to submit their email address to retrieve the
 * associated security question and initiate the process to request a password reset link.
 *
 * PureComponent: true
 * Redux Connected: true
 */
const ForgotPasswordEmailForm: React.FC<Props> = props => {

  const { handleSubmit, handleChange, isValid, values } = useFormik({
    initialValues:    {
      email: '',
    },
    onSubmit:         (values) => {
      props.getSecurityQuestion(values.email.trim());
      props.setEmailAddress(values.email.trim());
    },
    validationSchema: forgotPasswordEmailFormValidation,
    validateOnChange: false,
  });

  return (
    <div className={props.className}>
      <LocalDiv css={styles.header}>
        <Msg str={Str.EnterEmail} />
      </LocalDiv>
      <fieldset disabled={props.isLoading} css={styles.fieldset}>
        <form onSubmit={handleSubmit} css={styles.form}>
          {
            (props.emailAddressNotFound || !isValid) && (
              <div css={styles.errorMsg}>
                <Msg str={Str.LoginFailure} />
              </div>
            )
          }
          <LocalInput
            placeholderTranslation={Str.Email}
            name='email'
            type='text'
            value={values.email}
            css={styles.input}
            onChange={handleChange}
            autoComplete='off'
          />
          <LocalBtn str={Str.Continue} type='submit' css={styles.btn} />
        </form>
      </fieldset>
    </div>
  );
};

export default ForgotPasswordEmailForm;
